
(function(){

	const CHAT_API = 'https://automatisierung.test-torpedo.de/webhook/chat';
	const TOKEN_KEY = 'maxx_chat_session';
	const CONSENT_KEY = 'cookie_consent';
	const QUICK_REPLIES = ['Nächste Trainings', 'Was kostet ein Training?', 'Voraussetzungen', 'Wie buchen?'];

	function hasConsent(){
		return localStorage.getItem(CONSENT_KEY) && !document.querySelector('.cookie');
	}

	function escapeHtml(text){
		return text.replace(/[&<>"']/g, function(character){
			return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character];
		});
	}

	function formatReply(text){
		return escapeHtml(text || '')
			.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
			.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>')
			.replace(/\n/g, '<br>');
	}

	function addMessage(chat, text, type, html){
		const message = document.createElement('div');
		message.className = 'message ' + type;
		message[html ? 'innerHTML' : 'textContent'] = text;
		chat.appendChild(message);
		chat.scrollTop = chat.scrollHeight;
		return message;
	}

	function toggleWindow(section, open){
		const input = section.querySelector('input[type="text"]');
		section.classList.toggle('is-open', open);
		if(open && input) input.focus();
	}

	async function requestReply(userText){
		const body = {message: userText};
		const token = sessionStorage.getItem(TOKEN_KEY);
		if(token) body.session_token = token;

		const response = await fetch(CHAT_API, {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(body)
		});

		if(!response.ok) throw new Error('HTTP ' + response.status);

		const data = await response.json();
		if(data.session_token) sessionStorage.setItem(TOKEN_KEY, data.session_token);
		return data.reply || 'Dazu habe ich gerade keine Antwort bekommen.';
	}

	function initChatbot(section){
		if(section.dataset.chatbotReady) return;

		const chat = section.querySelector('.chat');
		const input = section.querySelector('input[type="text"]');
		const close = section.querySelector('.window .material');
		const openingButtons = Array.from(section.querySelectorAll('button'));

		if(!chat || !input) return;

		section.dataset.chatbotReady = 'true';
		section.classList.remove('is-consent-missing');
		input.placeholder = input.placeholder || 'Deine Frage';
		input.setAttribute('aria-label', 'Deine Frage');

		const quickReplies = document.createElement('div');
		quickReplies.className = 'quick-replies';
		QUICK_REPLIES.forEach(function(text){
			const button = document.createElement('button');
			button.type = 'button';
			button.textContent = text;
			button.addEventListener('click', function(){ submit(text); });
			quickReplies.appendChild(button);
		});
		chat.appendChild(quickReplies);

		openingButtons.forEach(function(button){
			button.addEventListener('click', function(){
				toggleWindow(section, !section.classList.contains('is-open'));
			});
		});

		if(close){
			close.addEventListener('click', function(){
				toggleWindow(section, false);
			});
		}

		input.addEventListener('keydown', function(event){
			if(event.key === 'Enter'){
				event.preventDefault();
				submit(input.value);
			}
		});

		async function submit(text){
			const userText = text.trim();
			if(!userText || section.classList.contains('is-loading')) return;

			input.value = '';
			input.disabled = true;
			section.classList.add('is-loading');
			addMessage(chat, userText, 'user');
			const loader = addMessage(chat, 'Bot tippt...', 'bot typing');

			try{
				const reply = await requestReply(userText);
				loader.remove();
				addMessage(chat, formatReply(reply), 'bot', true);
			}catch(error){
				loader.remove();
				addMessage(chat, 'Ups, da ist gerade etwas schiefgelaufen. Probier es bitte gleich nochmal.', 'bot');
			}finally{
				input.disabled = false;
				section.classList.remove('is-loading');
				input.focus();
			}
		}
	}

	function initAllowedChatbots(){
		document.querySelectorAll('section.chatbot').forEach(function(section){
			if(hasConsent()){
				initChatbot(section);
			}else{
				section.classList.add('is-consent-missing');
			}
		});
	}

	if(document.readyState === 'loading'){
		document.addEventListener('DOMContentLoaded', initAllowedChatbots);
	}else{
		initAllowedChatbots();
	}

	document.addEventListener('click', function(event){
		if(event.target.classList.contains('dismiss')){
			setTimeout(initAllowedChatbots, 0);
		}
	});

	document.addEventListener('keydown', function(event){
		if(event.key === 'Escape'){
			document.querySelectorAll('section.chatbot.is-open').forEach(function(section){
				toggleWindow(section, false);
			});
		}
	});

})();
